import React, { FunctionComponent, useEffect } from 'react'
import { map, uniqueId } from 'lodash'
import classnames from 'classnames'

import { Loading } from '../../../../components'

import accounting from 'accounting'
import styles from '../styles.module.css'
import { OutstandingBalanceReportingSummaryQueryVariables } from '../../../../generated/types'
import { useSelector } from 'react-redux'
import { State } from '../../../../reducers'
import { UserStore } from '../../../../typings/stores/UserStore'

interface SummaryProps {
  data: any
  loading: boolean
  error: boolean
  getData: ({ variables }) => void
}

const Summary: FunctionComponent<SummaryProps> = ({
  getData,
  data,
  loading,
  error,
}) => {
  const user = useSelector<State, UserStore>(state => state.user)

  const variables = () => {
    return {
      externalPublisherId: user.affiliateId,
    } as OutstandingBalanceReportingSummaryQueryVariables
  }

  const fetchData = () => {
    getData({ variables: variables() })
  }

  useEffect(fetchData, [user.affiliateId])

  if (loading) {
    return (
      <div className={classnames(styles.stateContainer, styles.loading)}>
        <Loading />
      </div>
    )
  }

  let totalAmount = -1
  return (
    <div className={styles.container}>
      {map(data, payload => {
        totalAmount = payload.summary.reduce((a, v) => a + v.total, 0)
        return (
          <div
            key={uniqueId('section-')}
            className={classnames(styles.section)}
          >
            <div className={styles.header}>
              <h4>Sales</h4>
              <span>{accounting.formatMoney(totalAmount, '$')}</span>
            </div>
            <div className={styles.breakdown}>
              {map(payload.summary, monthSummary => {
                // Setting the day in the middle of the month to avoid timezone issues
                const date = new Date(`${monthSummary.date}-15`)
                return (
                  <div
                    key={uniqueId('summary-breakdown-')}
                    className={styles.row}
                  >
                    <span>
                      {date.toLocaleString('default', { month: 'long' })}{' '}
                      {date.getFullYear()}
                    </span>
                    <span>
                      {accounting.formatMoney(monthSummary.total || 0, '$')}
                    </span>
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
      <div
        key={uniqueId('section-')}
        className={classnames(styles.section, styles.totalSection)}
      >
        <div className={styles.header}>
          <h4>Total</h4>
          <span>{accounting.formatMoney(totalAmount, '$')}</span>
        </div>
      </div>
    </div>
  )
}

export default Summary
